<template>
  <div class="d-flex pa-2 flex-row flex-wrap" :style="{ height: 'fit-content' }">
    <v-card
      class="d-flex pa-4 ma-2 flex-column"
      :style="{ height: 'fit-content', flex: '1', 'background-color': cardColor, color: textColor, }"
    >
      <div class="d-flex pa-2 flex-row" v-show="display">
        <h3 style="flex-grow: 1">
          <slot name="header">{{ title }}</slot>
        </h3>
        <v-btn icon @click="display = !display">
          <v-icon>{{ display ? 'mdi-chevron-up' : 'mdi-chevron-down' }}</v-icon>
        </v-btn>
      </div>

      <v-expand-transition>
        <div v-show="display">
          <v-divider />
          <v-row style="width: 100%" class="pa-4">
            <v-col cols="12" md="4">
              <v-text-field
                v-model="localSearch.file_name"
                label="Nama file"
                @enter="handleSearch"
                clearable
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="4">
              <v-autocomplete
              clearable
              v-model="localSearch.created_by"
              :items="itemsActiveUser"
              item-text="userID"
              item-value="id"
              label="Created By"
              :loading="loadingActiveUser"
              :search-input.sync="searchActiveUser"
              hide-selected
              hide-details="true"
              
            />
            </v-col>
            <v-col cols="12" md="4">
              <v-select
                :items="statusGenerateQr"
                v-model="localSearch.status"
                label="Status"
              />
            </v-col>
            <v-col v-if="isResetData" cols="12" md="4">
              <v-dialog
                v-model="localDateRangeDialog"
                persistent
                width="290px"
              >
                <template v-slot:activator="{ on, attrs }">
                  <v-text-field
                    prepend-icon="mdi-calendar"
                    readonly
                    v-bind="attrs"
                    v-on="on"
                    :value="localDateRangeDialogText"
                    label="Tanggal Upload"
                  />
                </template>
                <v-date-picker
                  v-model="localSearch.created_at"
                  scrollable
                  :max="getTommorowDate(0)"
                  @change="handleDateChange"
                  range
                >
                  <v-spacer />
                  <v-btn text color="primary" @click="handleDateCancel">
                    Cancel
                  </v-btn>
                  <v-btn
                    text
                    color="primary"
                    @click="handleDateConfirm"
                  >
                    OK
                  </v-btn>
                </v-date-picker>
              </v-dialog>
            </v-col>
          </v-row>

          <v-row class="pt-0 pb-4 px-2">
            <v-col cols="auto" class="d-flex justify-start pt-0 px-2">
              <v-btn @click.stop="resetFilter">Reset</v-btn>
            </v-col>
            <v-col cols="auto" class="d-flex justify-start pt-0 px-2">
              <v-btn color="primary" @click.stop="handleShowType">Show</v-btn>
            </v-col>
          </v-row>
        </div>
      </v-expand-transition>
    </v-card>
  </div>
</template>

<script>
import {
  statusGenerateQr,
  dataDelayServiceHit
} from '../../../store/params';
import { getTommorowDate, date } from '../../../lib/helpers';

export default {
  name: 'SearchFilter',
  props: {
    search: {
      type: Object,
      required: true,
    },
    rangeDateDialog: {
      type: Boolean,
      default: false,
    },
    dateRangeText: {
      type: String,
      default: '',
    },
    checkRangeDate: {
      type: Function,
      default: () => {},
    },
    title: {
      type: String,
      default: 'Search',
    },
    textColor: {
      type: String,
      default: 'black',
    },
    cardColor: {
      type: String,
      default: 'white',
    },
    isResetData: {
      type: Boolean,
      default: false,
    },
    getData : {
      type: Function,
      default: () => {},
    },
  },
  data() {
    return {
      localSearch: { ...this.search },
      localDateRangeDialog: this.rangeDateDialog,
      localDateRangeDialogText: this.dateRangeText,
      display: true,
      statusGenerateQr,
      dateDefault: date,
      searchActiveUser: '',
    };
  },
  watch: {
    searchActiveUser: {
      handler() {
        clearTimeout(this.delayHitService);
        this.delayHitService = setTimeout(() => {
          this.getActiveUser();
        }, dataDelayServiceHit);
      },
    },
    search: {
      handler(newSearch) {
        this.localSearch = { ...newSearch };
      },
      deep: true,
    },
    rangeDateDialog: {
      handler(newRangeDateDialog) {
        this.localDateRangeDialog = newRangeDateDialog;
      },
      deep: true,
    },
    dateRangeText: {
      handler(newDateRangeText) {
        this.localDateRangeDialogText = newDateRangeText;
      },
      deep: true,
    },
  },
  computed: {
    loadingActiveUser() {
      return this.$store.state.users.loadingActiveUser;
    },
    itemsActiveUser() {
      return this.$store.state.users.allActiveUser;
    },
  },
  methods: {
    getActiveUser() {
      this.$store.dispatch('users/getActiveUser', {
        date: this.dateDefault,
        userID: this.searchActiveUser,
        all: true,
      });
    },

    handleSearch() {
      this.$emit('search', { ...this.localSearch });
    },
    handleShowType() {
      this.$emit('showType', { ...this.localSearch });
    },
    getTommorowDate,
    handleDateChange(item) {
      if (Array.isArray(item) && item.length === 2) {
        this.localSearch.created_at = item;
      } else {
        this.localSearch.created_at = [item];
      }
    },
    handleDateCancel() {
      this.localDateRangeDialog = false;
      this.localSearch.created_at = [];
      this.localDateRangeDialogText = '';
    },
    resetFilter() {
      this.localSearch = {
        file_name: '',
        created_by: '',
        status: '',
        created_at: [],
      };
      
      this.localDateRangeDialogText = '';
      if (this.isResetData === true) {
        this.$emit('search', { ...this.localSearch });
        this.getData();
      }
    },
    handleDateConfirm() {
      this.localDateRangeDialog = false;

      if (Array.isArray(this.localSearch.created_at) && this.localSearch.created_at.length === 2) {
        const [startDate, endDate] = this.localSearch.created_at.sort((a, b) => new Date(a) - new Date(b));
        
        this.localSearch.created_at = [startDate, endDate];
        
        this.localDateRangeDialogText = `${startDate} ~ ${endDate}`;
      } else if (this.localSearch.created_at.length === 1) {
        this.localDateRangeDialogText = `${this.localSearch.created_at[0]}`;
      }

      this.emitCheckRangeDate();
    },
    emitCheckRangeDate() {
      this.$emit('check-range-date');
    },

  },
  beforeDestroy() { 
    this.resetFilter();
  },
};
</script>
